import {FETCH_RESULT, LIST_RESULT} from "./types";

const init = {
    isLoading: false,
    data: []
};
const resultHistory = (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_RESULT:
            return {
                ...state,
                isLoading: true
            };
        case LIST_RESULT:
            return {
                ...state,
                isLoading: false,
                data: payload.data
            };
        default:
            return state;
    }

}

export default resultHistory;